import { render, staticRenderFns } from "./drawer-filter.vue?vue&type=template&id=c2972a82&scoped=true"
import script from "./drawer-filter.vue?vue&type=script&lang=js"
export * from "./drawer-filter.vue?vue&type=script&lang=js"
import style0 from "./drawer-filter.vue?vue&type=style&index=0&id=c2972a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2972a82",
  null
  
)

export default component.exports